import React, { memo } from 'react'
import {
  useAnimatedContainer,
  AnimatedContainerProps,
} from './useAnimatedContainer'

const AnimatedContainer: React.FC<AnimatedContainerProps> = (
  props: AnimatedContainerProps
) => {
  const { ref, isVisible, children, animation, delay, extraCssClasses } =
    useAnimatedContainer(props)

  return (
    <div
      ref={ref}
      className={`animate__animated ${isVisible ? `animate__${animation}` : ''} ${delay ? `animate__delay-${delay}` : ''} ${extraCssClasses}`}
      style={{ opacity: isVisible ? 1 : 0 }}
    >
      {children}
    </div>
  )
}

export default memo(AnimatedContainer)
